import { Pipe, PipeTransform } from '@angular/core'
import moment from 'moment'

@Pipe({ name: 'relativeTime', standalone: false })
export class RelativeTimePipe implements PipeTransform {
  transform(value: Date, withoutSuffix?: boolean) {
    if (!(value instanceof Date)) {
      value = new Date(value)
    }

    return moment(value).local().fromNow(withoutSuffix)
  }
}
